import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from 'src/app/core/enviroment/environment.service';
import { CompanyConfigModel } from '../company-configuration.model';

@Injectable({
  providedIn: 'root'
})

export class CompanyConfigurationService {
  public uri = this.environmentService.getEnvVar('api_company');

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) { }

  public getCompanyAutoComplete(value: string) {
    let params = new HttpParams();
    params = params.append('value', value);
    params = params.append('max_value', '100');

    return this.http.get<any>(`${this.uri}/companies/autocomplete`, {params});
  }

  public getAgentAutoComplete(value: string, companyId: string) {
    let params = new HttpParams();
    params = params.append('value', value);
    params = params.append('max_results', '100');
    params = params.append('company', companyId);

    return this.http.get<any>(`${this.uri}/autocomplete/team/members`, {params});
  }

  public getCompanyConfig(id: string) {
    return this.http.get<any>(`${this.uri}/company-configuration/${id}`);
  }

  public updateCompanyConfig(company: CompanyConfigModel) {
    return this.http.post<any>(`${this.uri}/company/configuration`, company);
  }

  public postCompaniesList(sortItem = { field: 'company.name', type: 'ASC' }, searchField = '') {
    let body = {
      page_items: 10,
      page_number: 1,
      sorts: [
        sortItem
      ],
      search: {
        fields: [
          'company.name',
          'markets.name',
          'markets.market_subtype'
        ],
        value: searchField
      }
    };

    return this.http.post<any>(`${this.uri}/companies`, body);
  }

}
